<template>
  <modal
      :name="'transactionsSuspendedNoticeModal'"
      :adaptive="true"
      height="auto"
      :width="500"
      transition="linear"
      id="suspendTransactionsNoticeModal"
  >
    <modals-header
        :modalNameProp="$lang.messages.transactionsSuspendedModal"
        @hideModalProp="hideModal"
    />
    
    <hr class="v--modal-hr">
    
    <div class="fp-modal">
      <div class="part">
        <p class="label input-filter-label">
          {{ $lang.messages.transactionsSuspendedModalTextLine1 }}
        </p>
        <br>
        <p class="label input-filter-label">
          {{ $lang.messages.transactionsSuspendedModalTextLine2 }}
        </p>
      </div>
      
      <div class="part">
        <br>
        <p class="label input-filter-label">
          {{ $lang.messages.transactionsSuspendedModalTextLine3 }}
        </p>
        <ul>
          <li class="label input-filter-label">
            {{ $lang.messages.transactionsSuspendedModalTextBullet1 }}
          </li>
          <li class="label input-filter-label">
            {{ $lang.messages.transactionsSuspendedModalTextBullet2 }}
          </li>
          <li class="label input-filter-label">
            {{ $lang.messages.transactionsSuspendedModalTextBullet3 }}
          </li>
        </ul>
      </div>
      
      <button
          type="button"
          class="generic-btn"
          @click="hideModal"
      >
        {{ $lang.messages.cancel }}
      </button>
  
      <!-- SUBMIT -->
      <f-p-button-loader :loading="loading" :text="$lang.messages.resendEmail" @click.native="resendEmail" ></f-p-button-loader>
    </div>
  </modal>
</template>

<script>
  import { mapActions } from "vuex";
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import FPButtonLoader from "@/components/common/FPButtonLoader";
  
  export default {
    name: "TransactionsSuspendedNoticeModal",
    components: {
      'modals-header': modalsHeader,
      'f-p-button-loader': FPButtonLoader
    },
    data() {
      return {
        loading: false
      };
    },
    methods: {
      ...mapActions({
      
      }),
      /**
       * @description Show  modal
       */
      show() {
        this.$modal.show('transactionsSuspendedNoticeModal')
      },
      /**
       * @description Close modal
       */
      hideModal () {
        this.$modal.hide('transactionsSuspendedNoticeModal')
      },
      /**
       * @description Resend email
       */
      resendEmail () {
      
      }
    }
  }
</script>

<style scoped>

</style>
